import { render, staticRenderFns } from "./ActionModalThanks.vue?vue&type=template&id=e3f15a10&"
import script from "./ActionModalThanks.vue?vue&type=script&lang=js&"
export * from "./ActionModalThanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports